import React from 'react';
import SoaDisclaimerPicker from './SoaDisclaimerPicker';
import { SoaDisclaimerMode, SoaDisclaimerStatus, SoaDocument } from '@/types/soa';
import { Button } from '@/components/ui';
import styles from './SoaSendModal.module.css';

interface SoaDownloadDisclaimerDialogProps {
    document: SoaDocument;
    mode: SoaDisclaimerMode;
    onModeChange: (mode: SoaDisclaimerMode) => void;
    text: string;
    onTextChange: (text: string) => void;
    disclaimerStatus: SoaDisclaimerStatus | null;
    onDisclaimerStatusChange: (status: SoaDisclaimerStatus) => void;
    downloading: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

/** Same picker the send modal uses — this download exists specifically so the user
 *  can preview/test exactly what a send would attach before sending anything. */
const SoaDownloadDisclaimerDialog: React.FC<SoaDownloadDisclaimerDialogProps> = ({
    document, mode, onModeChange, text, onTextChange,
    disclaimerStatus, onDisclaimerStatusChange, downloading, onCancel, onConfirm,
}) => (
    <div className={styles.overlay} onClick={downloading ? undefined : onCancel}>
        <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <div className={styles.header}>
                <h3>Download 2 Pages + Disclaimer</h3>
                <p>{document.original_filename}</p>
            </div>

            <div className={styles.body}>
                <SoaDisclaimerPicker
                    mode={mode}
                    onModeChange={onModeChange}
                    text={text}
                    onTextChange={onTextChange}
                    disclaimerStatus={disclaimerStatus}
                    onDisclaimerStatusChange={onDisclaimerStatusChange}
                    disabled={downloading}
                />
            </div>

            <div className={styles.footer}>
                <Button onClick={onCancel} disabled={downloading}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={onConfirm}
                    disabled={
                        downloading
                        || (mode === 'pdf' && !disclaimerStatus?.exists)
                        || (mode === 'text' && !text.trim())
                    }
                >
                    {downloading ? 'Downloading…' : 'Download'}
                </Button>
            </div>
        </div>
    </div>
);

export default SoaDownloadDisclaimerDialog;
